import { TX_GRID_SORT_DISABLED, TX_GRID_SORT_ENABLED } from '../actions/tx_grid_sort'

export function txGridSort(state = { sortField: null, order: null }, action) {
  switch (action.type) {
    case TX_GRID_SORT_ENABLED:
      return { ...state, sortField: action.sortField, order: action.order }
    case TX_GRID_SORT_DISABLED:
      return { ...state, sortField: null, order: null }
    default:
      return state
  }
}
